<div [class.is-notification]="isNotification" class="ct-wr">
  <div [class.lg]="lgSize" [class.edit]="editDate">{{ text }}</div>
</div>
